import React from 'react';
import { CheckCircle } from 'lucide-react';
import DiagramGesamtsystem from './diagrams/DiagramGesamtsystem';
import DiagramEmailE2E from './diagrams/DiagramEmailE2E';
import Diagram8DWorkflow from './diagrams/Diagram8DWorkflow';
import DiagramKIDetail from './diagrams/DiagramKIDetail';
import DiagramEskalation from './diagrams/DiagramEskalation';
import DiagramBenutzer from './diagrams/DiagramBenutzer';
import DiagramQ2Workflow from './diagrams/DiagramQ2Workflow';
import DiagramQ3Workflow from './diagrams/DiagramQ3Workflow';
import DiagramEskalationQ2 from './diagrams/DiagramEskalationQ2';
import SectionReklamationErstellen from './sections/SectionReklamationErstellen';
import SectionRollen from './sections/SectionRollen';
import SectionKIFunktionen from './sections/SectionKIFunktionen';
import SectionQ2Supplier from './sections/SectionQ2Supplier';
import SectionQ3Internal from './sections/SectionQ3Internal';
import SectionSicherheitAudit from './sections/SectionSicherheitAudit';

export default function SectionContent({ id }) {
  switch (id) {
    case 'prozessfluss':
      return (
        <div className="space-y-8">
          <div className="p-3 rounded-lg bg-indigo-50 border border-indigo-200">
            <p className="text-xs text-indigo-800"><strong>9 End-to-End-Diagramme</strong> zeigen alle Szenarien des QM8D.ai-Systems: von allen 5 Eingangskanälen über KI-Analyse, Q2/Q3-Prozesse bis zur Eskalation und zum Abschluss mit PDF-Report.</p>
          </div>
          <DiagramGesamtsystem />
          <DiagramEmailE2E />
          <Diagram8DWorkflow />
          <DiagramKIDetail />
          <DiagramQ2Workflow />
          <DiagramQ3Workflow />
          <DiagramEskalation />
          <DiagramEskalationQ2 />
          <DiagramBenutzer />
        </div>
      );

    case 'create':
      return <SectionReklamationErstellen />;
    case 'ai':
      return <SectionKIFunktionen />;
    case 'q2':
      return <SectionQ2Supplier />;
    case 'q3':
      return <SectionQ3Internal />;
    case 'roles':
      return <SectionRollen />;
    case 'security':
      return <SectionSicherheitAudit />;

    case 'intro':
      return (<div className="space-y-3">
        <p className="text-sm leading-relaxed text-slate-700">QM8D.ai ist ein KI-gestütztes Reklamationsmanagementsystem zur strukturierten Bearbeitung von 8D/4D-Prozessen nach VDA- und IATF-Standards.</p>
        <div className="p-3 rounded-lg bg-blue-50 border border-blue-200">
          <p className="text-xs font-semibold mb-1 text-blue-700">Das System unterstützt:</p>
          <ul className="text-xs space-y-1 ml-3 list-disc text-slate-600">
            <li>Erfassung und Bearbeitung von Reklamationen</li>
            <li>Strukturierte Ursachenanalyse (6M, 5-Why, Ishikawa)</li>
            <li>KI-gestützte Vorschläge für Fehlercodes, Ursachen und Maßnahmen</li>
            <li>Automatische E-Mail-Verarbeitung mit KI-Datenextraktion</li>
            <li>Vollständige Dokumentation, PDF-Reports und Analytics</li>
          </ul>
        </div>
      </div>);

    case 'quickstart':
      return (<div className="space-y-3">
        <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide">In 5 Minuten zur ersten Reklamation</p>
        <div className="grid grid-cols-3 gap-2">
          {['1. Login', '2. Neue Reklamation', '3. Problembeschreibung', '4. KI-Analyse', '5. D-Schritte', '6. Abschluss (D8)'].map((s, i) => (
            <div key={i} className="p-2.5 rounded-lg text-center text-xs border bg-green-50 border-green-200 text-green-800"><span className="font-semibold">{s}</span></div>
          ))}
        </div>
      </div>);

    case 'login':
      return (<div className="space-y-3">
        <h4 className="text-sm font-semibold text-slate-800">Login</h4>
        <ol className="text-xs space-y-1 ml-4 list-decimal text-slate-600">
          <li>Anwendung öffnen</li><li>Benutzername und Passwort eingeben</li><li>Optional: 2FA-Code eingeben (falls aktiviert)</li>
        </ol>
        <h4 className="text-sm font-semibold text-slate-800">Navigation</h4>
        <div className="grid grid-cols-2 gap-2 text-xs">
          <div className="p-2 rounded border border-slate-200 bg-slate-50 text-slate-700"><strong>Sidebar links:</strong> Hauptnavigation</div>
          <div className="p-2 rounded border border-slate-200 bg-slate-50 text-slate-700"><strong>Header rechts:</strong> Suche, Benachrichtigungen, Hilfe</div>
        </div>
      </div>);

    case 'workflow':
      return (<div className="space-y-3">
        <h4 className="text-sm font-semibold text-slate-800">8D-Prozessablauf</h4>
        <div className="overflow-x-auto"><table className="w-full text-xs border-collapse"><thead><tr>
          <th className="text-left p-1.5 border-b-2 border-indigo-200 font-semibold text-indigo-700">Schritt</th>
          <th className="text-left p-1.5 border-b-2 border-indigo-200 font-semibold text-indigo-700">Beschreibung</th>
          <th className="text-left p-1.5 border-b-2 border-indigo-200 font-semibold text-indigo-700">KI</th>
        </tr></thead><tbody>
          {[['D0','Erfassung: Kundendaten, Produkt, Problem','E-Mail-Extraktion'],['D1','Team zusammenstellen','—'],['D2','Problembeschreibung detaillieren','Fehlercode-Zuordnung'],['D3','Sofortmaßnahmen (24-72h)','Maßnahmenvorschläge'],['D4','Ursachenanalyse (6M / 5-Why)','KI-Ursachenanalyse'],['D5','Korrekturmaßnahmen (7-30 Tage)','Maßnahmenvorschläge'],['D6','Wirksamkeitsprüfung','—'],['D7','Vorbeugungsmaßnahmen','—'],['D8','Abschluss und Bewertung','Quality-Score']].map(([s,d,a],i) => (
            <tr key={i} className={i%2===0?'bg-slate-50':''}><td className="p-1.5 font-semibold text-slate-800">{s}</td><td className="p-1.5 text-slate-600">{d}</td><td className="p-1.5 text-slate-500">{a}</td></tr>
          ))}
        </tbody></table></div>
        <div className="p-2 rounded-lg text-xs bg-blue-50 border border-blue-200 text-blue-800">
          <strong>4D-Prozess:</strong> D0 → D1 → D2 → D3 → D4 → D8 (ohne D5-D7).
        </div>
      </div>);

    case 'email':
      return (<div className="space-y-3">
        <h4 className="text-sm font-semibold text-slate-800">E-Mail-Verarbeitung</h4>
        <div className="text-xs space-y-1.5 text-slate-600">
          <p><strong className="text-slate-800">Automatisch:</strong> E-Mails werden alle 10 Sekunden abgerufen und per KI analysiert.</p>
          <p><strong className="text-slate-800">Zuordnung:</strong> Bestehende Reklamationsnummer erkannt → automatisch zugeordnet.</p>
          <p><strong className="text-slate-800">Rückfragen:</strong> Fehlende Pflichtdaten → automatische Rückfrage-E-Mail mit Webformular.</p>
          <p><strong className="text-slate-800">Archivierung:</strong> Jede E-Mail wird als PDF in Phase D0 archiviert.</p>
          <p><strong className="text-slate-800">Deduplizierung:</strong> Bereits verarbeitete E-Mails werden per message_id erkannt und ignoriert.</p>
        </div>
      </div>);

    case 'dashboard':
      return (<div className="space-y-3">
        <h4 className="text-sm font-semibold text-slate-800">Dashboard & Analytics</h4>
        <div className="grid grid-cols-3 gap-2 text-xs">
          {[{t:'KPIs',d:'Offene, überfällige Rekl.'},{t:'Trends',d:'Zeitreihen pro Monat'},{t:'Kosten',d:'CoPQ, Budget'},{t:'Ursachen',d:'Top-Fehler, Pareto'},{t:'Zeiten',d:'Durchlaufzeiten'},{t:'Export',d:'Excel + PDF'}].map((f,i) => (
            <div key={i} className="p-2 rounded-lg border border-cyan-200 bg-cyan-50 text-xs">
              <strong className="text-cyan-800">{f.t}</strong><br/><span className="text-slate-600">{f.d}</span></div>
          ))}
        </div>
      </div>);

    case 'admin':
      return (<div className="space-y-3">
        <h4 className="text-sm font-semibold text-slate-800">Rollen & Berechtigungen</h4>
        <div className="overflow-x-auto"><table className="w-full text-xs border-collapse"><thead><tr>
          <th className="text-left p-1.5 border-b-2 border-purple-200 text-purple-700">Rolle</th>
          <th className="text-left p-1.5 border-b-2 border-purple-200 text-purple-700">Rechte</th>
        </tr></thead><tbody>
          {[['Admin','Vollzugriff'],['Quality Manager','Bearbeitung + KI'],['Plant Manager','Werk-spezifisch'],['Coordinator','Delegation'],['Viewer','Nur Lesen']].map(([r,d],i) => (
            <tr key={i} className={i%2===0?'bg-slate-50':''}><td className="p-1.5 font-semibold text-slate-800">{r}</td><td className="p-1.5 text-slate-600">{d}</td></tr>
          ))}
        </tbody></table></div>
      </div>);

    case 'tips':
      return (<div className="space-y-2">
        <h4 className="text-sm font-semibold text-slate-800">Best Practices</h4>
        {['KI immer als Unterstützung nutzen — nie blind übernehmen','Ursachen strukturiert dokumentieren (6M-Kategorien)','D-Schritte vollständig ausfüllen (Quality Gates)','Regelmäßig Dashboard analysieren','E-Mail-Rückfragen zeitnah beantworten','PDF-Reports archivieren'].map((t,i) => (
          <div key={i} className="flex items-start gap-2 text-xs p-1.5"><CheckCircle className="w-3.5 h-3.5 flex-shrink-0 mt-0.5 text-green-600" /><span className="text-slate-700">{t}</span></div>
        ))}
      </div>);

    case 'faq':
      return (<div className="space-y-3">
        <h4 className="text-sm font-semibold text-slate-800">FAQ</h4>
        {[{q:'Ist KI verpflichtend?',a:'Nein. System funktioniert vollständig ohne KI.'},{q:'Wer trifft Entscheidungen?',a:'Immer der Benutzer.'},{q:'Daten nachträglich ändern?',a:'Ja, solange nicht abgeschlossen (D8).'},{q:'Falsche KI-Analyse?',a:'Vorschläge jederzeit anpassen oder verwerfen.'},{q:'Login geht nicht?',a:'Passwort/2FA prüfen. Bei Sperre Admin kontaktieren.'}].map((f,i) => (
          <details key={i}><summary className="text-xs font-semibold cursor-pointer p-2 rounded-lg hover:bg-slate-100 text-slate-800">{f.q}</summary><p className="text-xs text-slate-600 px-2 pb-2 pt-1">{f.a}</p></details>
        ))}
      </div>);

    default: return null;
  }
}
